import PropTypes from 'prop-types';
import SectionDivider from 'modules/shared/common/components/SectionDivider';
import { masterListFormValidationErrorType } from 'modules/labs/masterList/enums';
import InputField from 'modules/shared/common/components/InputField';
import ToggleBtn from 'modules/shared/common/components/ToggleBtn';
import {
  FormWrapper,
  FormGrid,
  FormLabel,
  FormFieldWrapper,
  ActivityFormFieldWrapper,
  FormValidationError,
} from './AddOrEditMasterListComponent.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddOrEditMasterListComponent = ({
  stringsData,
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
}) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleCheckboxFieldChange = (fieldName, fieldEvent) => {
    const { checked } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = checked;
      return fieldsObj;
    });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <FormWrapper>
      <FormGrid>
        {/* Name */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
            stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.englishName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.englishName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.englishName,
                event,
              )
            }
            name={stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.englishName}
          />
          {formFieldsValidation.englishName === masterListFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.masterListDetailsContent.masterListDetailsFormFields.formEmptyFieldError(
                  stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.englishName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
            stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.arabicName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicName,
                event,
              )
            }
            name={stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicName}
          />
          {formFieldsValidation.arabicName === masterListFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.masterListDetailsContent.masterListDetailsFormFields.formEmptyFieldError(
                  stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Display Name */}
        <FormFieldWrapper span={3}>
          <FormLabel>
            {stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
              stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys
                .englishDescription,
            )}
          </FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            as="textarea"
            value={formFieldsValues.englishDescription}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys
                  .englishDescription,
                event,
              )
            }
            name={
              stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.englishDescription
            }
          />
          {formFieldsValidation.englishDescription === masterListFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.masterListDetailsContent.masterListDetailsFormFields.formEmptyFieldError(
                  stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys
                    .englishDescription,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={3}>
          <FormLabel>
            {stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
              stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicDescription,
            )}
          </FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            as="textarea"
            value={formFieldsValues.arabicDescription}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys
                  .arabicDescription,
                event,
              )
            }
            name={
              stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.arabicDescription
            }
          />
          {formFieldsValidation.arabicDescription === masterListFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.masterListDetailsContent.masterListDetailsFormFields.formEmptyFieldError(
                  stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys
                    .arabicDescription,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* servicePrice */}
        <FormFieldWrapper span={6}>
          <FormLabel>{`${stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
            stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.servicePrice,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.servicePrice}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.servicePrice,
                event,
              )
            }
            leadingText={stringsData.masterListDetailsContent.masterListDetailsFormFieldsUnits.getFormFieldUnit(
              stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.servicePrice,
            )}
            name={stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.servicePrice}
          />
          {formFieldsValidation.servicePrice === masterListFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.masterListDetailsContent.masterListDetailsFormFields.formEmptyFieldError(
                  stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.servicePrice,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Is Searchable */}
        <ActivityFormFieldWrapper>
          <FormLabel>{`${stringsData.masterListDetailsContent.masterListDetailsFormFields.getFormFieldLabel(
            stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.isSearchable,
          )}*`}</FormLabel>
          <ToggleBtn
            onChange={event =>
              handleCheckboxFieldChange(
                stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.isSearchable,
                event,
              )
            }
            value={formFieldsValues.isSearchable}
            name={stringsData.masterListDetailsContent.masterListDetailsFormFieldKeys.isSearchable}
          />
        </ActivityFormFieldWrapper>
      </FormGrid>
    </FormWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};
export default AddOrEditMasterListComponent;

AddOrEditMasterListComponent.propTypes = {
  stringsData: PropTypes.shape({
    masterListDetailsContent: PropTypes.shape({
      masterListDetailsFormFields: PropTypes.shape({
        getFormFieldLabel: PropTypes.func,
        formEmptyFieldError: PropTypes.func,
        formWrongFieldErrorText: PropTypes.func,
      }),
      masterListDetailsFormFieldsUnits: PropTypes.shape({
        getFormFieldUnit: PropTypes.func,
      }),
      masterListDetailsFormFieldKeys: PropTypes.shape({
        englishName: PropTypes.string,
        englishDescription: PropTypes.string,
        englishAddress: PropTypes.string,
        arabicName: PropTypes.string,
        arabicDescription: PropTypes.string,
        arabicAddress: PropTypes.string,
        location: PropTypes.string,
        lat: PropTypes.string,
        long: PropTypes.string,
        contactPerson: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        servicePrice: PropTypes.string,
        partnershipDeliveryRadius: PropTypes.string,
        deliveryCharge: PropTypes.string,
        adminNote: PropTypes.string,
        isSearchable: PropTypes.string,
      }),
    }),
  }).isRequired,
  formFieldsValues: PropTypes.shape({
    englishName: PropTypes.string,
    englishDescription: PropTypes.string,
    englishAddress: PropTypes.string,
    arabicName: PropTypes.string,
    arabicDescription: PropTypes.string,
    arabicAddress: PropTypes.string,
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    long: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    contactPerson: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    servicePrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    partnershipDeliveryRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    deliveryCharge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    adminNote: PropTypes.string,
    isSearchable: PropTypes.bool,
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({
    englishName: PropTypes.number,
    englishDescription: PropTypes.number,
    englishAddress: PropTypes.number,
    arabicName: PropTypes.number,
    arabicDescription: PropTypes.number,
    arabicAddress: PropTypes.number,
    lat: PropTypes.number,
    long: PropTypes.number,
    contactPerson: PropTypes.number,
    email: PropTypes.number,
    phone: PropTypes.number,
    servicePrice: PropTypes.number,
    partnershipDeliveryRadius: PropTypes.number,
    deliveryCharge: PropTypes.number,
    adminNote: PropTypes.number,
    isSearchable: PropTypes.number,
  }).isRequired,
};

AddOrEditMasterListComponent.defaultProps = {};
